/**
 * @file コンポーネント：フル動画ページセッションエラーモーダル ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalErrorSession = (props) => {
    /**
     * モーダルを閉じてリダイレクトするユーザープレイログID付きのURL
     */
    const url = new URL(window.location.href);
    if (!url.searchParams.get("playLogId")) {
        url.searchParams.append("playLogId", props.userPlayLogId);
    }

    // Presenterに渡す
    return <Presenter url={url} />;
};
